import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import API_ENDPOINTS, { BASE_URL, UPLOAD_URL } from "@/util/api";
import { ANT_Upload } from "../styles";
import Button from "../../Button";

const FileUpload = ({ payload, onSuccess }) => {
  const token = localStorage.getItem("authToken");
  const props = {
    name: "file",
    action: UPLOAD_URL + API_ENDPOINTS.documentUpload,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: payload,
    onChange(info) {
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        const res = info?.file?.response?.body;
        onSuccess(res);
        // message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  return (
    <ANT_Upload {...props}>
      <Button icon={<UploadOutlined />}>Click to Upload</Button>
    </ANT_Upload>
  );
};
export default FileUpload;
